import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 12a6.03 6.03 0 016.029-6.03H16.5a6.03 6.03 0 010 12.06H7.529A6.03 6.03 0 011.5 12zm6.029-4.53a4.53 4.53 0 000 9.06H16.5a4.53 4.53 0 000-9.06H7.529z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 12a3 3 0 11-6 0 3 3 0 016 0zm9 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 12a6.03 6.03 0 016.029-6.03H16.5a6.03 6.03 0 010 12.06H7.529A6.03 6.03 0 011.5 12zm6.029-4.53a4.53 4.53 0 000 9.06H16.5a4.53 4.53 0 000-9.06H7.529z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 12a3 3 0 11-6 0 3 3 0 016 0zm9 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 24c0-6.657 5.397-12.06 12.058-12.06H33c6.659 0 12.058 5.403 12.058 12.06 0 6.66-5.4 12.059-12.058 12.059H15.058C8.398 36.059 3 30.659 3 24zm12.058-9.06C10.055 14.94 6 19 6 24a9.058 9.058 0 009.058 9.059H33a9.06 9.06 0 000-18.118H15.058z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 24a6 6 0 11-12 0 6 6 0 0112 0zm18 0a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }))
};
export var Adapt = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});